export default {"src":"/_next/static/media/Sassuolo.1db1e9fa.svg","height":86,"width":79,"blurWidth":0,"blurHeight":0};